import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { status } from 'constants/general';
import { registerFormStepsEnum } from 'modules/general/enums';
import RegisterForm from 'modules/general/components/RegisterForm';
import RegisterConfirmation from 'modules/general/components/RegisterConfirmation';
import RegisterError from 'modules/general/components/RegisterError';
import Loader from 'modules/common/components/Loader';
import SectionDivider from 'modules/common/components/SectionDivider';
import Logo from 'assets/images/logo.png';

import { Wrapper, LogoImg, LoaderWrapper } from './RegisterComponent.style';

const RegisterComponent = ({
  currentStep,
  formFieldsValues,
  formFieldsValidation,
  handleTextInputFieldChange,
  handleDropdownFieldChange,
  handleRadioBtnFieldChange,
  handleNextBtnClick,
  handleBackBtnClick,
}) => {
  const { citiesList } = useSelector(state => ({
    citiesList: state.common.citiesList,
  }));

  const renderRegisterForm = () => {
    if (citiesList.status === status.SHOULD_CALL_API || citiesList.status === status.FETCHING)
      return (
        <LoaderWrapper>
          <Loader />
        </LoaderWrapper>
      );

    if (currentStep === registerFormStepsEnum.confirmation) return <RegisterConfirmation />;

    if (currentStep === registerFormStepsEnum.error) return <RegisterError />;

    return (
      <RegisterForm
        currentStep={currentStep}
        formFieldsValues={formFieldsValues}
        formFieldsValidation={formFieldsValidation}
        handleTextInputFieldChange={handleTextInputFieldChange}
        handleDropdownFieldChange={handleDropdownFieldChange}
        handleRadioBtnFieldChange={handleRadioBtnFieldChange}
        handleNextBtnClick={handleNextBtnClick}
        handleBackBtnClick={handleBackBtnClick}
      />
    );
  };

  return (
    <Wrapper>
      <LogoImg src={Logo} />
      <SectionDivider gap={25} />
      {renderRegisterForm()}
    </Wrapper>
  );
};

RegisterComponent.propTypes = {
  currentStep: PropTypes.number.isRequired,
  formFieldsValues: PropTypes.shape().isRequired,
  formFieldsValidation: PropTypes.shape().isRequired,
  handleTextInputFieldChange: PropTypes.func.isRequired,
  handleDropdownFieldChange: PropTypes.func.isRequired,
  handleRadioBtnFieldChange: PropTypes.func.isRequired,
  handleNextBtnClick: PropTypes.func.isRequired,
  handleBackBtnClick: PropTypes.func.isRequired,
};

export default RegisterComponent;
